!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.dayjs_plugin_timezone = e();
}(this, function () {
  "use strict";

  var t = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
  },
      e = {};
  return function (n, i, r) {
    var o,
        u = r().utcOffset(),
        a = function a(t, n, i) {
      void 0 === i && (i = {});
      var r = new Date(t);
      return function (t, n) {
        void 0 === n && (n = {});
        var i = n.timeZoneName || "short",
            r = t + "|" + i,
            o = e[r];
        return o || (o = new Intl.DateTimeFormat("en-US", {
          hour12: !1,
          timeZone: t,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          timeZoneName: i
        }), e[r] = o), o;
      }(n, i).formatToParts(r);
    },
        f = function f(e, n) {
      for (var i = a(e, n), o = [], u = 0; u < i.length; u += 1) {
        var f = i[u],
            s = f.type,
            m = f.value,
            c = t[s];
        c >= 0 && (o[c] = parseInt(m, 10));
      }

      var d = o[3],
          v = 24 === d ? 0 : d,
          h = o[0] + "-" + o[1] + "-" + o[2] + " " + v + ":" + o[4] + ":" + o[5] + ":000",
          l = +e;
      return (r.utc(h).valueOf() - (l -= l % 1e3)) / 6e4;
    },
        s = i.prototype;

    s.tz = function (t, e) {
      void 0 === t && (t = o);
      var n = this.utcOffset(),
          i = this.toDate().toLocaleString("en-US", {
        timeZone: t
      }),
          a = Math.round((this.toDate() - new Date(i)) / 1e3 / 60),
          f = r(i).$set("millisecond", this.$ms).utcOffset(u - a, !0);

      if (e) {
        var s = f.utcOffset();
        f = f.add(n - s, "minute");
      }

      return f.$x.$timezone = t, f;
    }, s.offsetName = function (t) {
      var e = this.$x.$timezone || r.tz.guess(),
          n = a(this.valueOf(), e, {
        timeZoneName: t
      }).find(function (t) {
        return "timezonename" === t.type.toLowerCase();
      });
      return n && n.value;
    };
    var m = s.startOf;
    s.startOf = function (t, e) {
      if (!this.$x || !this.$x.$timezone) return m.call(this, t, e);
      var n = r(this.format("YYYY-MM-DD HH:mm:ss:SSS"));
      return m.call(n, t, e).tz(this.$x.$timezone, !0);
    }, r.tz = function (t, e, n) {
      var i = n && e,
          u = n || e || o,
          a = f(+r(), u);
      if ("string" != typeof t) return r(t).tz(u);

      var s = function (t, e, n) {
        var i = t - 60 * e * 1e3,
            r = f(i, n);
        if (e === r) return [i, e];
        var o = f(i -= 60 * (r - e) * 1e3, n);
        return r === o ? [i, r] : [t - 60 * Math.min(r, o) * 1e3, Math.max(r, o)];
      }(r.utc(t, i).valueOf(), a, u),
          m = s[0],
          c = s[1],
          d = r(m).utcOffset(c);

      return d.$x.$timezone = u, d;
    }, r.tz.guess = function () {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }, r.tz.setDefault = function (t) {
      o = t;
    };
  };
});